import React, {useContext, useRef} from 'react'
import {useParams} from "react-router";
import {makeStyles, Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpansionPanel from 'components/ExpansionPanel';
import ArrowIcon from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import {StageSectionsUrlParams, StageSectionParamToSectionName, StageSectionsComponents, StageSectionsTitles} from "../../constants/StageSections";
import RouterPath from "libs/RouterPath";
import {OfferSectionProvider} from "context/OfferSectionContext";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import {connect} from "react-redux";
import {simpleConfirm} from "libs/ConfirmNotification";


const useStyle = makeStyles(theme => ({
    rotate: {
        transform: 'rotate(180deg)'
    },
    adornmentGrid: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2)
        }
    },
    titleGrid: {
        '&>*:first-child': {
            flexGrow: 10000,
        }
    }
}))

function OfferExpansionSections(
    {
        section,
        stateCloseValidator
    }) {
    const classes = useStyle();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const openedSectionParam = params.section;
    const openedSection = openedSectionParam ? StageSectionParamToSectionName[openedSectionParam] : undefined;
    const expanded = openedSection === section.section;
    const panelRef = useRef();
    const purchaserOfferContext = useContext(PurchaserOfferContext)

    const handleClick = id => {

        if (section.status === DemandValidationSectionStatus.DISABLED)
            return false;


        if (stateCloseValidator && !stateCloseValidator()) {
            simpleConfirm("modification_cancel_popup_text", () => {
                doHandleClick(id)
            })
        } else {
            doHandleClick(id)
        }
    }

    const doHandleClick = id => {
        if (openedSection === id) {
            if (purchaserOfferContext) {
                RouterPath.redirectWithoutHistory(
                    RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID, {
                        id: demandId,
                        contractorDepartmentId: purchaserOfferContext.contractorDepartmentId,
                        stageId
                    })
                )
            } else {
                    RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID,
                        {id: demandId, stageId}))
            }
        } else {
            if (purchaserOfferContext) {
                RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID_SECTION, {
                    id: demandId,
                    contractorDepartmentId: purchaserOfferContext.contractorDepartmentId,
                    stageId,
                    section: StageSectionsUrlParams[id]
                }))
            } else {
                RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION, {
                    id: demandId,
                    stageId,
                    section: StageSectionsUrlParams[id]
                }))
            }
        }
    }

    const Component = StageSectionsComponents[section.section];
    const TitleComponent = StageSectionsTitles[section.section];
    return (
        <ExpansionPanel
            panelRef={panelRef}
            id={section.section}
            title={<TitleComponent expanded={expanded} section={section}/>}
            classesObj={{titleGrid: classes.titleGrid}}
            titleAdornment={
                <GridBlock
                    wrap='nowrap'
                    className={classes.adornmentGrid}
                    alignItems='center'
                >
                    <div/>
                    {section.status !== DemandValidationSectionStatus.DISABLED &&
                        <Tooltip title={expanded ? Tr('collapse') : Tr('expand')} placement='top'>
                            <ArrowIcon
                                className={clsx({
                                    [classes.rotate]: !expanded
                                })}
                            />
                        </Tooltip>}
                </GridBlock>
            }
            expanded={expanded}
            onChange={() => handleClick(section.section)}
        >
            {expanded && <OfferSectionProvider value={section}>
                <Component panelRef={panelRef} sectionId={section.section}/>
            </OfferSectionProvider>}
        </ExpansionPanel>
    )

}

OfferExpansionSections.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stateCloseValidator: state.stepper.stateCloseValidator}))(OfferExpansionSections);